'use es6';

import { ACTION_HUB_OPT_IN, ACTION_USER_OPT_IN } from 'ui-addon-opt/state/OptActions';
import { BetaButton } from './BetaButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultOptInButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "ui-addon-opt.optin.label"
});
const Optin = ({
  additionalOptions,
  dispatch,
  learnMore,
  onLearnMoreClick = emptyFunction,
  onMinimized = emptyFunction,
  onView = emptyFunction,
  optInButtonText = defaultOptInButtonText,
  showHubOptin = false,
  showUserOptin = true
}) => {
  return /*#__PURE__*/_jsx(Dropdown, {
    Button: BetaButton,
    buttonText: optInButtonText,
    onOpenComplete: onView,
    "data-test-id": "dropdown",
    children: /*#__PURE__*/_jsxs(List, {
      "data-test-id": "dropdownList",
      wrapChildren: true,
      children: [showUserOptin && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_USER_OPT_IN
        }),
        "data-test-id": "userOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.userOptin"
        })
      }), showHubOptin && /*#__PURE__*/_jsx(Button, {
        onClick: () => dispatch({
          type: ACTION_HUB_OPT_IN
        }),
        "data-test-id": "hubOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.hubOptin"
        })
      }), learnMore && /*#__PURE__*/_jsx(Button, {
        href: learnMore.url,
        onClick: onLearnMoreClick,
        target: "_blank",
        "data-test-id": "learnMoreButton",
        children: learnMore.text
      }), additionalOptions && additionalOptions.map(({
        text,
        onClick
      }, idx) => /*#__PURE__*/_jsx(Button, {
        onClick: onClick,
        "data-test-id": `additionalOptionsButton${idx}`,
        children: text
      }, `option-${idx}`)), /*#__PURE__*/_jsx(Button, {
        onClick: onMinimized,
        "data-test-id": "minimizeButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.common.options.minimize"
        })
      })]
    })
  });
};

// PropTypes removed for React 19 compatibility. Preserved for future TS migration:
// Optin.propTypes = {
//   additionalOptions: arrayOf(shape({ text: node.isRequired, onClick: func.isRequired })),
//   dispatch: func.isRequired,
//   learnMore: shape({ text: node.isRequired, url: string.isRequired }),
//   onLearnMoreClick: func,
//   onMinimized: func,
//   onView: func,
//   optInButtonText: node,
//   showHubOptin: bool,
//   showUserOptin: bool,
// };

export default Optin;